import React, { useState } from "react";
import "./infoicon.css";

const InfoIcon = ({text}) => {
  const [show, setShow] = useState(false);

  return (
    <div className="mob-info-container">
      <img
        className="img"
        src="/images/info.svg"
        alt="info"
        onClick={() => setShow(!show)}
        style={{ cursor: 'pointer' }}
      />
      {show ? (
        <div className="mob-info-text-container">
          {text}
        </div>
      ) : null}
    </div>
  );
};

export default InfoIcon;
